// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__Sl0-2","input":"styles_input__92NkC","btn_submit":"styles_btn_submit__Z18kn","change_password_button":"styles_change_password_button__743NA"};